module.exports = __webpack_public_path__ + "assets/a0e5f308a0a0f02626a0eac43097e5a7.png";